export default __webpack_public_path__ + "static/media/logo01.272036b0.svg";